<script>
import appConfig from "@/app.config";
import EventBus from "@/helpers/event-bus";
import VueCookies from "vue-cookies";

import { notificationMethods } from "@/state/helpers";
import ModalError from "@/components/share/modal-error.vue";
import ModalInfo from "@/components/share/modal-info.vue";
import Toast from "@/components/share/toast.vue";
import Swal from "sweetalert2";

import '@/assets/css/custom.css'

import {
  applicationComputed,
  groupComputed,
  groupMethods,
} from "@/state/helpers";

export default {
  name: "app",
  components: {
    "modal-error": ModalError,
    "modal-info": ModalInfo,
    toast: Toast,
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  computed: {
    ...applicationComputed,
  },
  created() {
    EventBus.$on("internalServerError", this.internalServerError);
  },
  mounted() {
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
    internalServerError(payload) {
      // var at = this.$cookies.get(".oauth.at")
      var url = `${process.env.VUE_APP_BASE_URL}/system-logs/${payload.data.traceIdentifierId}`;
      // console.log("payload", payload);
      Swal.fire({
        title: payload.statusText,
        icon: "error",
        html:
          payload.data.message +
          '<p><a target="_blank" href="' +
          url +
          '"><i class="bx bx-bug"></i></a></p>',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: "Dismiss",
        confirmButtonAriaLabel: "Thumbs up, great!",
      });
    },
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
    <modal-error />
    <modal-info />
    <toast />

    
  </div>
</template>
